import { Feather } from "@expo/vector-icons";
import { Q } from "@nozbe/watermelondb";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useEffect, useState } from "react";
import { useWithAppState } from "@towersystems/roam-common-native";
import Location from "../../../../utilities/data/model/Location";

export interface SetupLocationProps {
  afterSubmit?(locationId: string): void;
}

export const SetupLocation = ({ afterSubmit }: SetupLocationProps) => {
  const database = useDatabase();
  const [locations, setLocations] = useState<Location[] | undefined>();
  const { appState, updateAppState } = useWithAppState();
  const { locationId: activeLocationId } = appState;
  const { colors } = useThemeProvider();

  useEffect(() => {
    database
      .get<Location>("locations")
      .query(
        Q.or(
          Q.where("enabled", Q.eq(true)),
          Q.where("id", Q.eq(activeLocationId || ""))
        )
      )
      .fetch()
      .then((i) => setLocations(i));
  }, []);

  const handleOnSwitch = (locationId: string) => {
    updateAppState({
      locationId: locationId,
    });
    afterSubmit && afterSubmit(locationId);
  };

  const items: FlatActionListItem[] =
    locations?.map((location) => ({
      key: location.id,
      title: location.name,
      onPress: () => handleOnSwitch(location.id),
      componentRight: (icon) => {
        return activeLocationId === location.id ? (
          <Feather name="check" size={24} color={colors.primary} />
        ) : (
          icon
        );
      },
    })) || [];

  return (
    <Page
      title="Select a Location"
      titleContainerStyle={{ alignItems: "center" }}
    >
      <FlatActionList items={items} />
    </Page>
  );
};
